// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 完成媒体直传 服务端核验七牛对象元数据后幂等落库 POST /bossApi/conference/core/media/v1/completeDirectUpload */
export async function completeBossMediaDirectUpload(
  body: CoreAPI.CompleteDirectUploadHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseMultiMediaVO>(
    '/bossApi/conference/core/media/v1/completeDirectUpload',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 删除媒体 软删除指定媒体 POST /bossApi/conference/core/media/v1/deleteMedia */
export async function deleteBossMedia(
  body: CoreAPI.DeleteMediaHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.BaseResponse>(
    '/bossApi/conference/core/media/v1/deleteMedia',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 下载媒体文件 根据ID下载媒体原始文件 POST /bossApi/conference/core/media/v1/downloadMedia */
export async function downloadBossMedia(
  body: CoreAPI.DownloadMediaHttpRequest,
  options?: { [key: string]: any },
) {
  return request<any>('/bossApi/conference/core/media/v1/downloadMedia', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询媒体详情 根据ID查询媒体详情 POST /bossApi/conference/core/media/v1/getMedia */
export async function getBossMedia(
  body: CoreAPI.GetMediaHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseMultiMediaVO>(
    '/bossApi/conference/core/media/v1/getMedia',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 获取媒体访问地址 根据ID获取媒体访问地址 POST /bossApi/conference/core/media/v1/getMediaUrl */
export async function getBossMediaUrl(
  body: CoreAPI.GetMediaUrlHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseString>(
    '/bossApi/conference/core/media/v1/getMediaUrl',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 初始化媒体直传 签发短效、单对象、不可覆盖的七牛直传凭证 POST /bossApi/conference/core/media/v1/initDirectUpload */
export async function initBossMediaDirectUpload(
  body: CoreAPI.InitDirectUploadHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseDirectUploadInitVO>(
    '/bossApi/conference/core/media/v1/initDirectUpload',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询媒体列表 查询全部未删除的媒体列表 POST /bossApi/conference/core/media/v1/listMedia */
export async function listBossMedia(options?: { [key: string]: any }) {
  return request<CoreAPI.CommonResponseListMultiMediaVO>(
    '/bossApi/conference/core/media/v1/listMedia',
    {
      method: 'POST',
      ...(options || {}),
    },
  );
}

/** 分页查询媒体 分页查询媒体列表 POST /bossApi/conference/core/media/v1/pageMedia */
export async function pageBossMedia(
  body: CoreAPI.PageMediaHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonPageResponseMultiMediaVO>(
    '/bossApi/conference/core/media/v1/pageMedia',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 更新媒体 更新指定媒体的基础信息 POST /bossApi/conference/core/media/v1/updateMedia */
export async function updateBossMedia(
  body: CoreAPI.UpdateMediaHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.BaseResponse>(
    '/bossApi/conference/core/media/v1/updateMedia',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
